define.alias("shared/components/shared/wizards/carousel/step-two", "settings/components/shared/wizards/carousel/step-two");